module.exports = __webpack_public_path__ + "img/vuetify.ae7da443.png";